import { useCreditFacilityListSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { Navigate } from "react-router-dom";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CreditFacilityIndexPage: React.FC = () => {
  const { fundFamilyId } = useRequiredStringParams();

  const { data: creditFacilityList } =
    useCreditFacilityListSuspense(fundFamilyId);

  return (
    <Navigate
      replace={true}
      to={
        creditFacilityList.length
          ? rootRoute({})
              .fundFamilies({})
              .fundFamily({ fundFamilyId })
              .creditFacilities({})
              .creditFacility({ creditFacilityId: creditFacilityList[0].id }).$
          : rootRoute({})
              .fundFamilies({})
              .fundFamily({ fundFamilyId })
              .setup({})
              .creditFacilities({}).$
      }
    />
  );
};
